import {useState, useEffect} from 'react'
import {v4 as uuidv4} from 'uuid'
import MoneyDetails from '../MoneyDetails'
import TransactionItem from '../TransactionItem'

import './index.css'

const transactionTypeOptions = [
  {
    optionId: 'INCOME',
    displayText: 'Income',
  },
  {
    optionId: 'EXPENSES',
    displayText: 'Expenses',
  },
]

const MoneyManager = () => {
  const storedList = JSON.parse(localStorage.getItem('List'))
  const [title, setTitle] = useState('')
  const [amountInput, setAmount] = useState('')
  const [expense, setExpense] = useState(transactionTypeOptions[0].optionId)
  const [transactionList, setTransactionList] = useState(
    storedList === null ? [] : storedList,
  )

  const onChangeTitle = event => {
    setTitle(event.target.value.toUpperCase())
  }

  const onChangeAmount = event => {
    setAmount(event.target.value)
  }

  const onChangeOption = event => {
    setExpense(event.target.value)
  }

  const onSubmitAdd = event => {
    event.preventDefault()
    const typeOption = transactionTypeOptions.find(
      eachTransaction => eachTransaction.optionId === expense,
    )
    const {displayText} = typeOption
    const newTransactionItem = {
      id: uuidv4(),
      title,
      amount: parseInt(amountInput),
      type: displayText,
    }

    setTransactionList(prevState => [...prevState, newTransactionItem])
    setAmount('')
    setTitle('')
  }

  const onDelete = id => {
    const filterData = transactionList.filter(
      eachTransaction => eachTransaction.id !== id,
    )
    setTransactionList(filterData)
  }

  const getIncomeAmount = () => {
    let incomeAmount = 0
    transactionList.forEach(eachTransaction => {
      if (eachTransaction.type === transactionTypeOptions[0].displayText) {
        incomeAmount += eachTransaction.amount
      }
    })
    return incomeAmount
  }

  const getExpenseAmount = () => {
    let expenseAmount = 0
    transactionList.forEach(eachTransaction => {
      if (eachTransaction.type === transactionTypeOptions[1].displayText) {
        expenseAmount += eachTransaction.amount
      }
    })
    return expenseAmount
  }

  const getBalance = () => {
    let balanceAmount = 0
    let incomeAmount = 0
    let expenseAmount = 0

    transactionList.forEach(eachTransaction => {
      if (eachTransaction.type === transactionTypeOptions[0].displayText) {
        incomeAmount += eachTransaction.amount
      } else {
        expenseAmount += eachTransaction.amount
      }
    })

    balanceAmount = incomeAmount - expenseAmount
    return balanceAmount
  }

  useEffect(() => {
    localStorage.setItem('List', JSON.stringify(transactionList))
  })

  const incomeAmount = getIncomeAmount()
  const expenseAmount = getExpenseAmount()
  const balance = getBalance()
  return (
    <div className="bg-main-container">
      <div className="bg-container">
        <h1 className="manager-head">Hi,Joseph Developer</h1>
        <p className="manager-para">
          Welcome Back to your
          <span className="manager-span"> Money Manager</span>
        </p>
      </div>
      <MoneyDetails
        incomeAmount={incomeAmount}
        expenseAmount={expenseAmount}
        balance={balance}
      />
      <div className="money-manager-data">
        <form className="form-container" onSubmit={onSubmitAdd}>
          <h1>Add Transaction</h1>
          <label htmlFor="title">TITLE</label>
          <br />
          <input
            type="text"
            className="inputs"
            id="title"
            onChange={onChangeTitle}
            value={title}
          />
          <br />
          <label htmlFor="amount">AMOUNT</label>
          <br />
          <input
            type="number"
            className="inputs"
            id="amount"
            onChange={onChangeAmount}
            min="1"
            value={amountInput}
          />
          <br />
          <label htmlFor="options">TYPE</label>
          <br />
          <select id="options" className="inputs" onChange={onChangeOption}>
            {transactionTypeOptions.map(eachTransaction => (
              <option
                id={eachTransaction.optionId}
                value={eachTransaction.optionId}
              >
                {eachTransaction.displayText}
              </option>
            ))}
          </select>
          <br />
          <button type="submit" className="manager-button">
            Add
          </button>
        </form>
        <div className="money-item-container">
          <h1>History</h1>
          <ul className="transaction-table">
            <li className="table-header">
              <p className="table-header-cells">Title</p>
              <p className="table-header-cells">Amount</p>
              <p className="table-header-cells">Type</p>
            </li>
            {transactionList.map(eachTransaction => (
              <TransactionItem
                eachTransaction={eachTransaction}
                key={eachTransaction.id}
                onDelete={onDelete}
              />
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default MoneyManager
